import { render } from "./app-modal-add-tax.vue?vue&type=template&id=4556cf26"
import script from "./app-modal-add-tax.vue?vue&type=script&lang=js"
export * from "./app-modal-add-tax.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-add-tax.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4556cf26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4556cf26', __exports__)) {
    console.log('reload')
    api.reload('4556cf26', __exports__)
  }
  
  module.hot.accept("./app-modal-add-tax.vue?vue&type=template&id=4556cf26", () => {
    console.log('re-render')
    api.rerender('4556cf26', render)
  })

}


export default __exports__